'use client';

import { IconName, Tabs, TabsItem } from '@bytel/trilogy-react-ts';

import { JOURNEYS } from '@app-types/product';

import { useHome } from '@landing/hooks';

type Tabs = { label: string; icon: IconName; key: JOURNEYS }[];
export function HomeTabs() {
    const { otisConfigurator, setOtisConfigurator, setSelectedFaiProduct, setSelectedPlan, setSelectedFaiOption } =
        useHome();
    const tabsContent: Tabs = [
        {
            label: 'Forfaits mobile',
            icon: IconName.SIM_CARD,
            key: JOURNEYS.BYOU,
        },
        {
            label: 'Offres fibre',
            icon: IconName.BOX,
            key: JOURNEYS.FAI,
        },
    ];
    const onChangeTabs = (key: JOURNEYS) => {
        setOtisConfigurator(key);
        if (key === JOURNEYS.BYOU) {
            setSelectedFaiProduct(null);
            setSelectedFaiOption('');
        } else {
            setSelectedPlan(null);
        }
    };
    return (
        <div className='home-tabs'>
            <Tabs className='is-icons'>
                {tabsContent.map((tab) => (
                    <TabsItem
                        testId={`home-tab-${tab.key}`}
                        key={tab.key}
                        iconName={tab.icon}
                        active={otisConfigurator.value === tab.key}
                        onClick={() => onChangeTabs(tab.key)}
                        id={tab.key}
                    >
                        {tab.label}
                    </TabsItem>
                ))}
            </Tabs>
        </div>
    );
}
